import * as map from '../map'
import 'leaflet.markercluster'
import 'leaflet.markercluster/dist/MarkerCluster.css'
import 'leaflet.markercluster/dist/MarkerCluster.Default.css'
import '../imports/L.RotatedMarker'
import { targetEmitTypeString } from '../const'
import * as L from 'leaflet'
import { writable } from 'svelte/store'
import preferences from '../preferences'

export const MAX_MARKER_MISS_TIME = 5 * 1000 // 5s
export const MAX_LAST_SEEN = 30 * 1000 // 30s
const EARTH_RADIUS_MILES = 3963

const stalkTimeInMinutes = 2
const adsbRangeLimit = [0, 50000]


const pref = preferences('adsbRange', adsbRangeLimit)

const emitterIcon = [
	{file:"Marker_Airplane", width:35, height:35},
	{file:"WTC-Light-1-Prop", width:32, height:32},
	{file:"Marker_Airplane", width:35, height:35},
	{file:"Type-GLFx", width:40, height:40},
	{file:"Marker_Airplane", width:35, height:35},
	{file:"Marker_Airplane", width:35, height:35},
	{file:"Marker_Airplane", width:35, height:35},
	{file:"Helicopter", width:32, height:32},
	{file:"Marker_Airplane", width:35, height:35},
	{file:"Type-GLID", width:60, height:60},
	{file:"Balloon", width:20, height:25},
	{file:"Marker_Airplane", width:35, height:35},
	{file:"Marker_Airplane", width:35, height:35},
	{file:"Marker_Airplane", width:35, height:35},
	{file:"Marker_Airplane", width:35, height:35},
	{file:"Marker_Airplane", width:35, height:35},
	{file:"Marker_Airplane", width:35, height:35},
	{file:"svs", width:40, height:40},
	{file:"svs", width:40, height:40},
	{file:"Marker_Airplane", width:35, height:35}
]


Number.prototype.toRad = function() {
	return this * Math.PI / 180;
}

Number.prototype.toDeg = function() {
	return this * 180 / Math.PI;
}

export const filteredPingStationCount = writable(0)

export default class ADSBMarkerSet {
	filterRadioId = null
	adsbRange = adsbRangeLimit

	constructor(name, options = {}, overlayParent) {    
		this.addedLayer = true
		this.layer = L.markerClusterGroup({
			disableClusteringAtZoom:9,
			removeOutsideVisibleBounds:true,
			maxClusterRadius:40
		})
		this.layer.addTo(map.getMap())
		this.overlay = map.addOverlay(name, this.layer, overlayParent)

		// this.headingLayer = L.layerGroup()
		// this.headingLayer.addTo(this.layer)
		// addOverlay("Headings", this.headingLayer, this.parentSegment)

		this.options = {
			maxLastSeen: options.maxLastSeen || MAX_LAST_SEEN
		}

		this.markers = {}
		pref.subscribe(value => {
			this.adsbRange = value
			this.filterAltitude()
		})
	}

	update(data, now) {
		if (!now) now = Date.now()

		let markerInfo = this.markers[data.icao]

		if (now - data.lastSeen > this.options.maxLastSeen) {
			// console.log("Skipping stale", data.callsign || data.icao, now, data.lastSeen, (now - data.lastSeen)/1000)
			if (markerInfo) {
				if (markerInfo.marker) this.layer.removeLayer(markerInfo.marker)
				delete this.markers[data.icao]
			}
			return
		}

		if (!data.latitude || !data.longitude) return
		
		let pos = [data.latitude, data.longitude]
		// Get a marker for a new one
		const {details, title} = this.getDetails(data)
		if (!markerInfo) {
			let iconInfo = emitterIcon[data.emitterType || 0]
			if (!iconInfo || !iconInfo.file) {
				iconInfo = emitterIcon[0]
			}

			const iconConfig = L.icon({
				iconUrl: `/images/types/${iconInfo.file}-Selected.png`,
				iconSize: iconInfo ? [iconInfo.width, iconInfo.height]: [20, 20],
				iconAnchor: iconInfo ? [iconInfo.width / 2, iconInfo.height / 2]: [10, 10]
			});
    
			let marker = L.marker(pos, { icon: iconConfig, title })
			this.layer.addLayer(marker)
			if (this.filterRadioId && !data.pingStations[this.filterRadioId]) {
				marker.setOpacity(0.3)
			}
			markerInfo = {marker, details, pingStations:data.pingStations}
			if (this.markers[data.icao]) {
				console.error("REPLACING")
			}
			this.markers[data.icao] = markerInfo

			marker.bindTooltip(details, {offset:[20, 0]})

			marker.on("add", () => {
				markerInfo.hidden = false
				if (markerInfo.selected) this.updateStalk(markerInfo)
        
				// if (markerInfo.headingLine) markerInfo.headingLine.removeFrom(markerInfo.markerLayer)
				// if (markerInfo.headingDot) markerInfo.headingDot.removeFrom(markerInfo.markerLayer)
				// if (map.getMap().getZoom() < 9) return
				// this.updateStalk(markerInfo)
			})
			marker.on("remove", () => {
				markerInfo.hidden = true
				this.cleanExtras(markerInfo)
			})
			marker.on("mouseover", () => {
				this.updateStalk(markerInfo)
			})
			marker.on("mouseout", () => {
				if (!markerInfo.selected) {
					this.cleanExtras(markerInfo)
				}
			})
			marker.on("click", (ev) => {
				if (ev.originalEvent.ctrlKey && ev.originalEvent.altKey && data.callsign) {
					window.open(`https://flightaware.com/live/flight/${data.callsign}`, 'new')
				}
				markerInfo.selected = !markerInfo.selected
				const selectedIconConfig = L.icon({
					iconUrl: `/images/types/${iconInfo.file}${markerInfo.selected ? "" : "-Selected"}.png`,
					iconSize: iconInfo ? [iconInfo.width, iconInfo.height]: [20, 20],
					iconAnchor: iconInfo ? [iconInfo.width / 2, iconInfo.height / 2]: [10, 10]
				});
				marker.setIcon(selectedIconConfig)
				if (!markerInfo.selected) {
					this.cleanExtras(markerInfo)
				}
			})
		} else if (markerInfo.timestamp > data.lastSeen) {
			return
		}
		
		// if (!details) details = this.getDetails(data).details
		markerInfo.marker.setLatLng(pos)
		markerInfo.marker.setTooltipContent(details)
		if (data.headingDE2) {
			markerInfo.marker.setRotationAngle(data.headingDE2 / 100)
		}
		markerInfo.timestamp = data.lastSeen
		markerInfo.latestData = data

		if (this.markerAltitudeFilter(markerInfo)) {
			markerInfo.marker.addTo(this.layer)
		} else {
			markerInfo.marker.removeFrom(this.layer)
		}
		// this.updateStalk(markerInfo)
	}

	updateStalk(markerInfo) {
		if (!markerInfo.latestData) return
		if (!markerInfo.marker) return
		if (markerInfo.hidden) return

		if (!markerInfo.latestData.headingDE2) return
    
		let pos = markerInfo.marker.getLatLng()
		// const pt = map.getMap().latLngToContainerPoint(pos)
		let cartHeading = markerInfo.latestData.headingDE2 / 100
		// if (cartHeading < 0) cartHeading += 360
		// const rads = cartHeading * Math.PI / 180

		function stalkPt(heading, minutes) {
			const travelDistance = ((markerInfo.latestData.horVelocityCMS /  0.0514444) / 1000) * (minutes/60)
			const d = travelDistance / EARTH_RADIUS_MILES
			const brng = heading.toRad()
			const lat = pos.lat.toRad()
			const lng = pos.lng.toRad()
			const lat2 = Math.asin( Math.sin(lat)*Math.cos(d) + Math.cos(lat)*Math.sin(d)*Math.cos(brng) )
			const lng2 = lng + Math.atan2(Math.sin(brng)*Math.sin(d)*Math.cos(lat), Math.cos(d)-Math.sin(lat)*Math.sin(lat2))
			return [lat2.toDeg(), lng2.toDeg()]
		}
  
		const headingPt = stalkPt(cartHeading, stalkTimeInMinutes)

		if (isNaN(headingPt[0]) || isNaN(headingPt[1])) {
			return
		}
    
		if (!markerInfo.headingLine) {
			markerInfo.headingLine = L.polyline([pos, headingPt], {color: "yellow", weight:1})
			markerInfo.headingLine.addTo(map.getMap())
		} else {
			markerInfo.headingLine.setLatLngs([pos, headingPt])
		}
		if (!markerInfo.headingDot) {
			markerInfo.headingDot = L.circle(headingPt, {color:"yellow", radius:10})
			markerInfo.headingDot.addTo(map.getMap())
		} else {
			markerInfo.headingDot.setLatLng(headingPt)
		}
	}

	getDetails(data) {
		let details = "ICAO: " + data.icao;
		let title;
		if (data.callsign && data.callsign.trim()) {
			details += "<br>Callsign: " + data.callsign.trim();
			title = data.callsign.trim();
		}
		else {
			title = data.icao;
		}
		if (data.emitterType) {
			details += "<br>Type: " + targetEmitTypeString[data.emitterType];
		}
		if (data.altitude) {
			details += "<br>Altitude: " + Math.round(data.altitude / 304.8) + " ft";
		}
		if (data.headingDE2) {
			details += "<br>Heading: " + Math.round(data.headingDE2 / 100);
		}
		if (data.horVelocityCMS) {
			details += "<br>Velocity: " + Math.round(data.horVelocityCMS / 51.4444) + " knots";
		}
		if (data.squawk) {
			details += "<br>Squawk: " + data.squawk;
		}
		if (data.lastSeen) {
			details += "<br>Last Update: " + new Date(data.lastSeen).toLocaleString()
		}
  
		return {details, title}
	}

	clean(timestamp) {
		for (const [key, markerInfo] of Object.entries(this.markers)) {
			if (timestamp - markerInfo.timestamp > this.options.maxLastSeen) {
				if (markerInfo.marker) this.layer.removeLayer(markerInfo.marker)
				this.cleanExtras(markerInfo)
				delete this.markers[key]
			}
		}
	}

	cleanExtras(markerInfo) {
		if (markerInfo.headingLine) {
			markerInfo.headingLine.removeFrom(map.getMap())
			markerInfo.headingLine = null
		}
		if (markerInfo.headingDot) {
			markerInfo.headingDot.removeFrom(map.getMap())
			markerInfo.headingDot = null
		}
	}

	clear() {
		for (const markerInfo of Object.values(this.markers)) {
			if (markerInfo.marker) this.layer.removeLayer(markerInfo.marker)
			this.cleanExtras(markerInfo)
		}
		this.markers = []
	}

	cleanup() {
		this.clear()
		map.removeOverlay(this.overlay)
	}

	filter(filterRadioId) {
		this.filterRadioId = filterRadioId
		let ct = 0
		for (const markerInfo of Object.values(this.markers)) {
			const {marker, pingStations} = markerInfo
			if (filterRadioId && !pingStations[filterRadioId]) {
				marker.setOpacity(0.3)
			} else {
				marker.setOpacity(1.0)
				ct++
			}
		}
		filteredPingStationCount.set(filterRadioId ? ct : null)
	}

	filterAltitude() {
		for (const markerInfo of Object.values(this.markers)) {
			if (this.markerAltitudeFilter(markerInfo)) {
				markerInfo.marker.addTo(this.layer)
			} else {
				markerInfo.marker.removeFrom(this.layer)
			}
		}
	}

	markerAltitudeFilter(markerInfo) {
		if (!markerInfo.latestData.altitude) return true
		const alt = markerInfo.latestData.altitude / 1000 / 0.3048 //convert to feet
		const min = this.adsbRange[0]
		const max = this.adsbRange[1]
		return (alt >= min || min <= adsbRangeLimit[0]) && 
			(alt <= max || max >= adsbRangeLimit[1])
	}
}
